module.exports = __webpack_public_path__ + "img/linux.a86c6852.svg";